import barChartHoverPinch from './animated-icons/bar-chart-pinch.json';
import woodenBoxHoverPinch from './animated-icons/wooden-box-pinch.json';
import puzzleHoverDetach from './animated-icons/puzzle-hover-detach.json';
import dandelionHoverPinch from './animated-icons/dandelion-hover-pinch.json';
import stockShareHoverPinch from './animated-icons/stock-share-hover-pinch.json';
import marketingLetterHoverPinch from './animated-icons/marketing-letter-pinch.json';
import engagementAltHoverPinch from './animated-icons/engagement-alt-hover-pinch.json';
import consultationHoverConversation from './animated-icons/consultation-hover-conversation.json';

/**
 * Interface for a set of Lordicon animations
 */
export interface LordiconSet {
  [key: string]: any;
}

export const mainIcons: LordiconSet = {
  'wired-outline-bar-chart-pinch': { body: barChartHoverPinch },
  'wired-outline-wooden-box-pinch': { body: woodenBoxHoverPinch },
  'wired-outline-puzzle-hover-detach': { body: puzzleHoverDetach },
  'wired-outline-dandelion-hover-pinch': { body: dandelionHoverPinch },
  'wired-outline-marketing-letter-pinch': { body: marketingLetterHoverPinch },
  'wired-outline-stock-share-hover-pinch': { body: stockShareHoverPinch },
  'wired-outline-engagement-alt-hover-pinch': { body: engagementAltHoverPinch },
  'wired-outline-consultation-hover-conversation': { body: consultationHoverConversation },
};

/**
 * All icon sets combined
 */
export const allIconSets: Record<string, LordiconSet> = {
  main: mainIcons,
};

/**
 * Get an icon definition by its full name (set:iconName)
 * @param fullName The full name of the icon in the format 'set:iconName'
 * @returns The icon definition or undefined if not found
 */
export function getIconByName(fullName: string): any | undefined {
  const [setName, iconName] = fullName.split(':');

  if (!setName || !iconName) {
    return undefined;
  }

  const iconSet = allIconSets[setName];

  if (!iconSet) {
    return undefined;
  }

  return iconSet[iconName];
}

/**
 * List of all available icon names in the format 'set:iconName'
 */
export const allIconNames = Object.entries(allIconSets).flatMap(([setName, iconSet]) =>
  Object.keys(iconSet).map((iconName) => `${setName}:${iconName}`)
);

/**
 * Type for icon names that can be used with the Lordicon component
 */
export type LordiconName = (typeof allIconNames)[number];
